import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import MainVisual from '../home/components/MainVisual';
import ReasonSection from '../home/components/ReasonSection';
import SurveySection from '../home/components/SurveySection';
import FaqSection from '../home/components/FaqSection';
import { SurveyProvider } from '../../contexts/SurveyContext';

export default function Affiliate() {
  return (
    <SurveyProvider>
      <div style={{ minHeight: '100vh', maxWidth: '480px', margin: '0 auto', overflowX: 'hidden' }}>
        <Header />
        <main>
          <MainVisual isAffiliate />
          <ReasonSection />
          <SurveySection isAffiliate />
          <FaqSection />
        </main>
        <Footer />
      </div>
    </SurveyProvider>
  );
}
